/**
 * Split Content Card — video popover iframe lifecycle.
 *
 * Lazy-loads the iframe when popover opens and clears src on close so
 * background audio does not continue after dismiss.
 */

document.querySelectorAll('.split-content-card__video-popover').forEach((popover) => {
  const iframe = popover.querySelector('.split-content-card__video-iframe');
  if (!iframe) {
    return;
  }

  const iframeSrc = iframe.dataset.src || '';
  if (iframeSrc === '') {
    return;
  }

  popover.addEventListener('toggle', (event) => {
    if (event.newState === 'open') {
      iframe.src = iframeSrc;
      return;
    }

    iframe.src = '';
  });
});
